
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MethodFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"methods"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analog_signal_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analog_signal_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buffer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flow_rate_ml_per_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fraction_collector_interval_sec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fraction_collector_starts_with_vial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"injection_ms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"injection_sec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"injection_ul"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"measurements"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobile_phase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"needle_depth_mm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pressure_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pressure_reach_sec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refill_flow_rate_ml_per_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"run_time_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"run_time_ms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shaking_duration_ms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shaking_duration_sec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solvents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"syringe_refill_speed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_routine"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_position_plan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wash_after_injection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gradient"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fraction_collector_start_delay_sec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detector_single_channel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calibration_delay_sec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"favorite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archived"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"temperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hardware_configuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_initial_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_does_change_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_change_position_after_sec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_example"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_advanced_mode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wash_after_injection_vial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wash_after_injection_time_sec"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":893}};
    doc.loc.source = {"body":"fragment MethodFragment on methods {\n  analog_signal_description\n  analog_signal_type\n  buffer\n  comment\n  flow_rate_ml_per_min\n  fraction_collector_interval_sec\n  fraction_collector_starts_with_vial\n  id\n  injection_ms\n  injection_sec\n  injection_ul\n  measurements\n  mobile_phase\n  name\n  needle_depth_mm\n  pressure_min\n  pressure_reach_sec\n  refill_flow_rate_ml_per_min\n  run_time_min\n  run_time_ms\n  shaking_duration_ms\n  shaking_duration_sec\n  solvents\n  syringe_refill_speed\n  valve_routine\n  valve_position_plan\n  wash_after_injection\n  gradient\n  fraction_collector_start_delay_sec\n  detector_single_channel\n  calibration_delay_sec\n  favorite\n  archived\n  editable\n  temperature\n  hardware_configuration\n  valve_initial_position\n  valve_does_change_position\n  valve_change_position_after_sec\n  is_example\n  is_advanced_mode\n  wash_after_injection_vial\n  wash_after_injection_time_sec\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["MethodFragment"] = oneQuery(doc, "MethodFragment");
        
